export const bars = {
	title: "Bares",
	description:
		"Los operadores vinculados a estos bares tendrán estos productos disponibles",
	actions: {
		linkBars: "Agregar a los bares",
		unlinkBars: "Desvincular bar",
		linkBar: "vincular bar",
		unlinkBar: "desvincular bar",
		next: "Siguiente",
		back: "Volver",
	},
	notifications: {
		success: "Producto vinculado con éxito a los bares seleccionados.",
		error: "Algunos enlaces fallaron. Inténtalo de nuevo más tarde.",
		genericError: "Error al vincular producto a los bares. Inténtalo de nuevo más tarde.",
		unlinkSuccess: "Producto desvinculado con éxito del bar.",
		genericUnlinkError:
			"Error al desvincular producto del bar. Inténtalo de nuevo más tarde.",
	},
	unlinkBarsConfirmation: {
		title: "Desvincular bar",
		message:
			"¿Desea remover el vínculo con este bar? Si lo hace, su producto ya no estará disponible para consumo en el bar.",
		confirm: "Desvincular bar",
		cancel: "Cancelar",
	},
	labels: {
		linkedBars: "Bares vinculados",
		optional: "Opcional",
		selectBars: "Elija los bares donde su producto estará activo.",
		stock: "Stock",
		ip: "IP de la impresora",
	},
	fields: {
		searchLabel: "Bares disponibles",
		searchPlaceholder: "Buscar un bar",
	},
	emptyState: {
		title: "No hay bares vinculados aún",
		description:
			"Agregue bares para hacer que este producto esté disponible para el consumo allí.",
	},
};
